(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('components/jwplayer.html', '<div id=\"video-player\" width=\"100%\" height=\"100%\"></div>\n<div class=\"jw__controls\">\n\n  <button class=\"jw__play-button\" ng-class=\"{\'is-paused\': !isPlaying, \'is-loading\': isLoading}\" ng-click=\"toggleVideo()\">\n    <span ng-if=\"isPlaying\">Pauzeren</span>\n    <span ng-if=\"!isPlaying\">Afspelen</span>\n    <span ng-if=\"isLoading\">Laden</span>\n  </button>\n\n  <span class=\"jw__timing\" ng-if=\"showDetails\">{{ position }} / {{ duration }}</span>\n</div>\n');
    }]);
})();